import React from 'react';

const HK = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_139"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_139)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#DE2910"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.155 7.514C7.44299 6.366 8.64499 2.83 11.24 3.006C10.714 3.276 10.638 3.78 10.938 4.246C11.274 4.77 10.908 5.611 10.454 5.816C9.70799 6.151 9.55899 7.046 10.154 7.514H10.155ZM10.382 7.392C10.635 4.459 14.372 4.509 15.002 7.03C14.584 6.615 14.082 6.698 13.73 7.128C13.337 7.608 12.424 7.518 12.09 7.151C11.54 6.547 10.64 6.681 10.382 7.393V7.392ZM10.474 7.685C13.354 7.07 14.398 10.657 12.171 11.999C12.447 11.476 12.221 11.019 11.707 10.809C11.133 10.573 10.951 9.674 11.205 9.247C11.623 8.544 11.231 7.724 10.475 7.684L10.474 7.685ZM6.74999 10.98C7.32999 11.08 7.69499 10.723 7.73599 10.17C7.78299 9.55 8.58099 9.1 9.06599 9.21C9.86399 9.39 10.523 8.764 10.326 8.032C11.802 10.582 8.71299 12.682 6.74899 10.979L6.74999 10.98ZM6.15299 5.5C6.26799 6.078 6.73099 6.29 7.26299 6.13C7.85799 5.952 8.56499 6.536 8.63599 7.03C8.75399 7.838 9.57399 8.228 10.186 7.784C8.33599 10.074 5.26599 7.944 6.15299 5.499V5.5Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default HK;
